/*
*###############################################################################
*Module Name                   : VoucherBarcodePrint.js                          #
*Purpose of the Module         :                                               #
*Description of the Module     :                                               #
*Original Author               :  W M Shanika Chamodi                          #
*Date                          : Thursday, January 12th 2022, 9:51:24 am        #
*Copyright © 2022 myPOS Software Solution (pvt Ltd.)                           #
*###############################################################################
*/
import React, { useState, useEffect } from "react"
import { MetaTags } from "react-meta-tags"
import { Card, Col, Container, Row, CardBody } from "reactstrap"

//**Importing required componant files   */
import Breadcrumb from "components/Common/Breadcrumb"
import DPTopToolBar from "framework/widgets/DPTopToolBar"
import VoucherBarcodePrintContent from "./VoucherBarcodePrintContent"
import DPInfoBox from "framework/layout/DPInfoBox"
import { Text } from "../../../framework/validators/TextValidation"
import DPAlert from "../../../framework/widgets/DPAlert"
import DPLoadingAlert from 'framework/widgets/DPLoadingAlert'
import DPPermission from "framework/widgets/DPPermission"
import { getVoucherPrintSummary, setVoucherSave } from "./VoucherBarcodePrintController"
//*Detail content */
import VoucherBarcodePrintDetails from "./VoucherBarcodePrintDetails"
import { Context } from '../../../app-contexts/CommonContexts';
import { useHistory } from 'react-router-dom';
import { useContext } from "react"
//**End Importing required componant files */

const VoucherBarcodePrint = props => {

  let history = useHistory();
  const {
    getMenuDetails, masterAuditLog, addtoFavourite
  } = useContext(Context);
  //*** User input related states */
  const [strVoucherFrom, SetVoucherFrom] = useState("") // Set Code
  const [blVoucherFromEnable, SetVoucherFromEnable] = useState(false)
  const [strVoucherTo, SetVoucherTo] = useState("") // Set Code
  const [blVoucherToEnable, SetVoucherToEnable] = useState(false)
  const [strBookFrom, SetBookFrom] = useState("")
  const [blBookFromEnable, SetBookFromEnable] = useState(false)
  const [strBookTo, SetBookTo] = useState("")
  const [blBookToEnable, SetBookToEnable] = useState(false)
  const [strGrnNo, SetGrnNo] = useState("")
  const [blGrnNoEnable, SetGrnNoEnable] = useState(false)
  const [addNew, SetAddNew] = useState(true)
  const [handleClearStatus, setHandleClearStatus] = useState(false)

  //*** End User input related states */

  //*** User Activity related states*/
  const [AlertMsg, setAlertMsg] = useState("")
  const [AlertColor, setAlertColor] = useState("")
  const [AlertShow, setAlertShow] = useState(false)
  const [ShowTaxTable, setShowTaxTable] = useState(false)
  const [blDiasableGrid, SetblDiasableGrid] = useState(false)

  const [modal_xlargeVoucherFrom, setmodal_xlargeVoucherFrom] = useState(false)
  const [modal_xlargeMainVoucherTo, setmodal_xlargeVoucherTo] = useState(false)
  const [modal_xlargeBookFrom, setmodal_xlargeBookFrom] = useState(false)
  const [modal_xlargeBookTo, setmodal_xlargeBookTo] = useState(false)
  const [modal_xlargeGrn, setmodal_xlargeGrn] = useState(false)

  const [disabledDesc, setDisabledDesc] = useState(false)
  const [disabledCode, setDisabledCode] = useState(false)
  const [saveEnable, setSaveEnable] = useState(true)
  const [crEnable, setCrEnable] = useState(false)
  const [crBy, setCrBy] = useState("")
  const [mdBy, setMdBy] = useState("")
  const [crDate, setCrDate] = useState("")
  const [mdDate, setMdDate] = useState("")
  const [SupplierOpen, SetSupplieropen] = useState(false)
  const [menuCode, SetMenuCode] = useState("")

  //*** End User activity related staes */

  //*** useState to save table data */
  const [DataTablesVoucher, SetDatatableVoucher] = useState([])
  const [DataTablesBook, SetDatatableBook] = useState([])
  const [DataTablesGRN, SetDatatableGRN] = useState([])



  const [strReason, setReason] = useState("Created")
  //*** End of useStates */

  const [disabled, setDisabled] = useState(false)
  const [rowsTax, setrowsTax] = useState([])
  const [rowsLoadVoucher, setLoadVoucher] = useState([{ id: 1 }])



  /**********Loading Alert */
  const [loadingAlert, SetLoadingAlert] = useState(false)
  const [loadingAlertTitle, SetLoadingAlerttitle] = useState("")
  /**********End Loading Alert */

  //User Permission related usestates
  const [permissionAlertShow, setPermissionAlertShow] = useState(false)
  const [permissionAlertTitle, setPermissionAlertTitle] = useState("")
  const [permissionReasonShow, setPermissionReasonShow] = useState(false)
  const [permissionName, setPermissionName] = useState("")
  const [permissionPassword, setPermissionPassword] = useState("")
  const [permissionNameDisable, setPermissionNameDisable] = useState(false)

  //*****Menu Rights Start*/
  const [menuAccess, SetMenuAccess] = useState(false)
  const [menuCreate, SetMenuCreate] = useState(false)
  const [menuDelete, SetMenuDelete] = useState(false)
  const [menuModify, SetMenuModify] = useState(false)
  const [menuPrint, SetMenuPrint] = useState(false)
  const [menuProcess, SetMenuProcess] = useState(false)
  const [menuName, SetMenuName] = useState("")
  const [parentName, SetParentName] = useState("")
  const [LocationCode, setLocationCode] = useState("")
  const [LogUserType, setLogUserType] = useState("")
  const [LogCompanyCode, setLogCompanyCode] = useState("")
  //*****Menu Rights End */
  const [helpUrl, setHelpUrl] = useState("")
  var time = process.env.REACT_APP_ALERTTIMEOUT

  //**Get File Details */
  useEffect(async () => {
    var obj = JSON.parse(localStorage.getItem("authUser"))
    var LogUserType = obj[2]
    var menuDetail = await getMenuDetails(window.location.pathname)
    var menu = menuDetail && menuDetail.menuTag ? menuDetail.menuTag : history.push('/dashboard');
    var parentname = menuDetail?.parentName
    SetParentName(parentname)
    var LocationCode = obj[3]
    var CompanyCode = obj[5]
    setLocationCode(LocationCode)
    setLogUserType(LogUserType)
    setLogCompanyCode(CompanyCode)
    const ApiURL = window.Links.ApiURL
    const authToken = localStorage.getItem("authToken")
    var requestOptions = {
      method: 'GET',
      headers: {
        "Authorization": `Bearer ${authToken}`
      },
      redirect: 'follow'
    };

    fetch(`${ApiURL}login/menu/${LogUserType}/${menu}`, requestOptions)
      .then(response => response.json())
      .then(result => {
        setPermissionReasonShow(result.data.strMenuReasonShow)
        SetMenuAccess(result.data.strMenuAccessRight)
        SetMenuCreate(result.data.strMenuCreateRight)
        SetMenuDelete(result.data.strMenuDeleteRight)
        SetMenuModify(result.data.strMenuModifyRight)
        SetMenuPrint(result.data.strMenuPrintRight)
        SetMenuProcess(result.data.strMenuProcessRight)
        SetMenuName(result.data.strMenuName)
        SetMenuCode(result.data.strMenuTag)
        setHelpUrl(result.data.strHelpUrl)
      }).catch(error =>
        console.log('error', error)
      );

  }, [])


  // AuditLog
  useEffect(async () => {
    var obj = JSON.parse(localStorage.getItem("authUser"))
    var LogUserType = obj[2]
    var LocationCode = obj[3]
    var CompanyCode = obj[5]
    var menuDetail = await getMenuDetails(window.location.pathname)
    var menu = menuDetail && menuDetail.menuTag ? menuDetail.menuTag : history.push("/dashboard")

    await masterAuditLog(menu, LogUserType, LocationCode, CompanyCode) //masterfile access log
  }, [])


  //Alert Parameter
  const [sweetAlertShow, setsweetAlertShow] = useState(false)
  const [AlertDescription, setAlertDescription] = useState(false)
  const [AlertConfirmOption, setAlertConfirmOption] = useState(0)

  function tog_xlargeFromvoucher() {
    setmodal_xlargeVoucherFrom(!modal_xlargeVoucherFrom)
    removeBodyCss()
  }

  function tog_xlargeTovoucher() {
    setmodal_xlargeVoucherTo(!modal_xlargeMainVoucherTo)
    removeBodyCss()
  }

  function tog_xlargeFromBook() {
    setmodal_xlargeBookFrom(!modal_xlargeBookFrom)
    removeBodyCss()
  }

  function tog_xlargeToBook() {
    setmodal_xlargeBookTo(!modal_xlargeBookTo)
    removeBodyCss()
  }

  function tog_xlargeGrn() {
    setmodal_xlargeGrn(!modal_xlargeGrn)
    removeBodyCss()
  }

  var searchDataVoucher = []
  const TableDataBuilderVoucher = (id, Data) => {
    return {
      id: id,
      code: Data.code

    }
  }

  var searchDataBook = []
  const TableDataBuilderBook = (id, Data) => {
    return {
      id: id,
      code: Data.code

    }
  }
  var searchDataGrn = []
  const TableDataBuilderGrn = (id, Data) => {
    return {
      id: id,
      code: Data.strRunNo,
      name: Data.strLocCode,
      active: Data.strSupCode,
      GrossAmt: Data.dbGrossAmount,
      NetAmount: Data.dbNetAmount,
      crby: Data.createdBy,
      crdate: Data.createdDate,

    }
  }


  //removebodyCss function
  function removeBodyCss() {
    document.body.classList.add("no_padding")
  }


  //*** Get user selected row details */

  const GetSelectRowVoucherFrom = (e, row, isSelect, rowIndex) => {
    SetVoucherFrom(row.VC_NUMBER)
    setmodal_xlargeVoucherFrom(!modal_xlargeVoucherFrom)

  }
  const GetSelectRowVoucherTo = (e, row, isSelect, rowIndex) => {
    SetVoucherTo(row.VC_NUMBER)
    setmodal_xlargeVoucherTo(!modal_xlargeMainVoucherTo)

  }
  const GetSelectRowBookFrom = (e, row, isSelect, rowIndex) => {
    SetBookFrom(row.VC_BOOKNO)
    setmodal_xlargeBookFrom(!modal_xlargeBookFrom)

  }
  const GetSelectRowBookTo = (e, row, isSelect, rowIndex) => {
    SetBookTo(row.VC_BOOKNO)
    setmodal_xlargeBookTo(!modal_xlargeBookTo)
  }
  const GetSelectRowMainGrn = (e, row, isSelect, rowIndex) => {
    SetGrnNo(row.HED_RUNNO)
    setmodal_xlargeGrn(!modal_xlargeGrn)

  }
  //*** End of getSelectedRow function */

  //edit button function
  const handleEdit = e => {
    setDisabledDesc(false)
    setDisabledCode(true)
    setSaveEnable(true)
  }

  //new button function
  const handleNew = e => {
    ClearItem()
    setAlertMsg(false)
    setSaveEnable(true)
  }

  //clear fields function
  const ClearItem = () => {

    SetVoucherFrom("")
    setHandleClearStatus(prev => !prev)
    SetVoucherTo("")
    SetBookFrom("")
    SetBookTo("")
    SetGrnNo("")
    setLoadVoucher([])
    SetVoucherFromEnable(false)
    SetVoucherToEnable(false)
    SetBookFromEnable(false)
    SetBookToEnable(false)
    SetGrnNoEnable(false)
    setAlertShow(false)
    setSaveEnable(true)
    setCrEnable(false)
    setTimeout(() => {
      setLoadVoucher([{ id: 1 }])
    }, 1)
  }

  const columnsVoucher = [
    {
      dataField: "id",
      text: "Id",
      sort: true,
    },
    {
      dataField: "code",
      text: "Voucher No",
      sort: true,
    },

  ]

  const columnsBook = [
    {
      dataField: "id",
      text: "Id",
      sort: true,
    },
    {
      dataField: "code",
      text: "Book No",
      sort: true,
    },

  ]
  const columnsGrn = [
    {
      dataField: "id",
      text: "Id",
      sort: true,
    },
    {
      dataField: "code",
      text: "Code",
      sort: true,
    },
    {
      dataField: "name",
      text: "Name",
      sort: true,
    },
    {
      dataField: "active",
      text: "Active",
      sort: true,
    },
    {
      dataField: "GrossAmt",
      text: "Gross Amount",
      sort: true,
    },
    {
      dataField: "NetAmount",
      text: "Net Amount",
      sort: true,
    },
    {
      dataField: "crby",
      text: "Created by",
      sort: true,
    },
    {
      dataField: "crdate",
      text: "Created on",
      sort: true,
    },

  ]
  //default sorted method
  const defaultSorted = [
    {
      dataField: "id",
      order: "asc",
    },
  ]
  //default sorted method
  const defaultSortedMain = [
    {
      dataField: "id",
      order: "asc",
    },
  ]
  //Voucher Po table Array
  const VoucherPoBuilder = (
    code,
    desc,
    GRNDate,
    Reference,
    SellingPrice,
    LocationCode,
    LogUserType
  ) => {
    return {

      PLU_VOUCHERCODE: code,
      PLU_DESC: desc,
      PLU_REF: Reference,
      PLU_SELL: parseFloat(SellingPrice),
      PLU_GRNDATE: GRNDate,
      PLU_USERID: LogUserType,
      PLU_LOCATION: LocationCode,

    }
  }

  //save button function
  const handlesave = async () => {
    // e.preventDefault()
    var VoucherPoDet = []


    rowsLoadVoucher.forEach((item, index) => {
      VoucherPoDet.push(
        VoucherPoBuilder(
          item.code,
          item.desc,
          item.grnDate,
          item.reference,
          item.sellingPrice,
          LocationCode,
          LogUserType,
        )
      )
    })




    if (VoucherPoDet.length <= 1) {
      displayAlertMessage('danger', "Need to Load at least one Voucher Number !")
      return
    }


    //loading alert show
    SetLoadingAlert(true)
    if (addNew == true) {
      SetLoadingAlerttitle("Saving...")
    } else {
      SetLoadingAlerttitle("Updating...")
    }

    let strResult = await setVoucherSave(
      LocationCode,
      LogUserType,
      VoucherPoDet

    )
    SetLoadingAlert(false)
    if (strResult.status == "200") {
      strResult.json().then(responseData => {

        if (responseData.data == "Record Already Exsist!") {
          displayAlertMessage('danger', responseData.data)

        } else if (responseData.data == "Code Already Exsist!") {
          displayAlertMessage('danger', responseData.data)

        } else {
          handleNew()
          displayAlertMessage('success', responseData.data + "Please Use the third party software to print your barcodes Now")

        }
      })
    } else if (strResult.status == "400") {
      strResult.json().then(responseData => {
        setAlertMsg(responseData.msg)

      })
      setAlertColor("danger")
      //setAlertMsg("Oops something went wrong !")
      setAlertShow(true)
    } else {
      handleNew()
    }
    setTimeout(() => {
      setAlertShow(false)
    }, 6000)
  }


  //**Permission Check */
  const permission = (operation) => {
    const authToken = localStorage.getItem("authToken")
    const ApiURL = window.Links.ApiURL
    const permissiondata = {
      "strUsername": permissionName,
      "strPassword": permissionPassword,
      "strLocation": LocationCode,
      "strMenuCode": menuCode
    }

    clearPermissionInputs()

    fetch(`${ApiURL}login/userpermission`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${authToken}`
        },
        body: JSON.stringify(permissiondata)
      }
    ).then(Response => {
      if (Response.status == "200") {
        Response.json()
          .then(responseData => {

            let Access = (responseData.data.strMenuAccessRight)
            let Create = (responseData.data.strMenuCreateRight)
            let Delete = (responseData.data.strMenuDeleteRight)
            let Modify = (responseData.data.strMenuModifyRight)
            let Print = (responseData.data.strMenuPrintRight)
            let Process = (responseData.data.strMenuProcessRight)

            if (operation == "Save") {
              if (Create == true) {
                handlesave()
              } else if (Modify == true) {
                handlesave()
              } else {
                if (operation == "Save" && addNew == true) {
                  displayAlertMessage('danger', "This user dosen't have permission to save")

                } else {
                  displayAlertMessage('danger', "This user dosen't have permission to edit")

                }
              }
            } else if (operation == "Delete") {
              if (Delete == true) {
                handleDelete()
              } else {
                displayAlertMessage('danger', "This user don't have permission to delete !")

              }
            }
          }
          )

      } else if (Response.status == "400") {
        setDisabled(false)
        setDisabledCode(false)
        displayAlertMessage('danger', "Oops something went wrong !")
        clearPermissionInputs()

      } else if (Response.status == "403") {
        setDisabled(false)
        setDisabledCode(false)
        displayAlertMessage('danger', "You have not Permission to make changes !")
        clearPermissionInputs()

      } else if (Response.status == "404") {
        setDisabled(false)
        setDisabledCode(false)
        displayAlertMessage('danger', "Password or User Name is Invalid !")
        clearPermissionInputs()

      } else {
        ClearItem()
      }
    }).catch(error => {

    })
  }

  //Function for display Alert Messages
  function displayAlertMessage(color, message) {
    setAlertColor(color)
    setAlertMsg(message)
    setAlertShow(true)

    setTimeout(() => {
      setAlertShow(false)
    }, time)
  }


  //handle permission alert
  function handlePermissionAlert(LogUserType, reason, disable, alertShow) {
    setPermissionName(LogUserType)
    setReason(reason)
    setPermissionNameDisable(disable)
    setPermissionAlertShow(alertShow)
  }


  //Clear permission name & password
  function clearPermissionInputs() {
    setPermissionName("");
    setPermissionPassword("");
    setReason("");
  }

  //Handle Favourite Button
  const handleFavourite = async () => {
    var response = await addtoFavourite(menuCode, LogUserType);
    console.log(response)
  }


  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Voucher Barcode Printing</title>
        </MetaTags>
        <Container fluid={true}>
          <Breadcrumb
            title="Vouchers"
            breadcrumbItem="Voucher Barcode Printing"
          ></Breadcrumb>
          <DPAlert
            confirm_both={sweetAlertShow}
            title={"Voucher Barcode Printing!"}
            description={AlertDescription}
            showCancel={true}
            btnColor={"success"}
            cancelColor={"danger"}
            onConfirm={() => {
              setsweetAlertShow(false)
              if (AlertConfirmOption == 1) {
                //alert(permissionReasonShow)
                if (addNew == true && menuCreate == true && permissionReasonShow == false) {
                  handlesave()
                } else if (addNew == true && menuCreate == true && permissionReasonShow == true) {
                  handlePermissionAlert(LogUserType, "Created", true, true)

                } else if (addNew == false && menuModify == true && permissionReasonShow == false) {
                  handlesave()
                } else if (addNew == false && menuModify == true && permissionReasonShow == true) {
                  handlePermissionAlert(LogUserType, "Updated", true, true)

                } else {
                  setPermissionReasonShow(true)
                  setPermissionAlertShow(true)
                }

              } else if (AlertConfirmOption == 2) {
                handleEdit()
              } else if (AlertConfirmOption == 3) {
                window.location.href = "/";
              } else if (AlertConfirmOption == 4) {
                handleNew()
              }

            }}
            onCancel={() => {
              setsweetAlertShow(false)
              clearPermissionInputs()
            }}
            SupplierOpen={SupplierOpen}
            SetSupplieropen={() => {
              SetSupplieropen(!SupplierOpen)
            }}
          />
          <DPPermission
            confirm_both={permissionAlertShow}
            title={menuName}
            description={permissionAlertTitle}
            showReason={permissionReasonShow}
            nameDisable={permissionNameDisable}
            showCancel={true}
            btnColor={"success"}
            cancelColor={"danger"}
            AlName={permissionName}
            AlNameOnchange={e => {
              let val2 = Text(e.target, 50, true, false, "any", true)
              setPermissionName(val2)
            }}
            AlPassward={permissionPassword}
            AlPasswardOnchange={e => {
              let val2 = Text(e.target, 50, true, true, "any", true)
              setPermissionPassword(val2)
            }}
            AlReason={strReason}
            AlReasonOnchange={e => {
              let val2 = Text(e.target, 50, true, false, "any", true)
              setReason(val2)
            }}
            onConfirm={() => {
              setPermissionAlertShow(false)
              if (AlertConfirmOption == 1) {
                permission("Save")
              } else if (AlertConfirmOption == 5) {
                permission("Delete")
              }
            }}
            onCancel={() => {
              setPermissionAlertShow(false)
              clearPermissionInputs()
            }}
          />
          <DPLoadingAlert
            confirm_both={loadingAlert}
            title={loadingAlertTitle}
          />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <DPTopToolBar
                    //Help Button
                    helpEnable={helpUrl != "" ? true : false}
                    helpClick={() => {
                        window.open(helpUrl)
                    }}
                    //Favorite Button
                    favoriteEnable={true}
                    favoriteClick={handleFavourite}
                    //New Button
                    newEnable={true}
                    newClick={() => {
                      setAlertDescription("Do you wish to refresh the screen ?")
                      setAlertConfirmOption(4)
                      setsweetAlertShow(true)
                    }}
                    //Save Button
                    saveEnable={saveEnable}
                    saveClick={() => {
                      setAlertDescription("Do you wish to save ?")
                      setAlertConfirmOption(1)
                      setsweetAlertShow(true)
                    }}
                    //ProcessButton
                    processEnable={false}
                    processClick={() => {
                      alert("Process")
                    }}
                    //Edit Button
                    editEnable={false}
                    editClick={() => {
                      setAlertDescription("Do you wish to edit ?")
                      setAlertConfirmOption(2)
                      setsweetAlertShow(true)
                    }}
                    //Print Button
                    printEnable={false}
                    printClick={() => {
                      alert("Print")
                    }}
                    //Delete Button
                    deleteEnable={false}
                    deleteClick={() => {
                      alert("Delete")
                    }}
                    //Exit Button
                    exitEnable={true}
                    exitClick={() => {
                      setAlertDescription("Do you wish to exit ?")
                      setAlertConfirmOption(3)
                      setsweetAlertShow(true)
                    }}
                  />
                  <Row>
                    <VoucherBarcodePrintContent

                      Gen_VoucherFrom={strVoucherFrom}
                      Gen_VoucherFrom_OnChange={e => {
                        let valCode = Text(
                          e.target,
                          13,
                          true,
                          false,
                          "upper",
                          false
                        )
                        SetVoucherFrom(valCode)
                      }}
                      Gen_VoucherFrom_Enabled={blVoucherFromEnable}
                      Gen_VoucherTo={strVoucherTo}
                      Gen_VoucherTo_OnChange={e => {
                        let valCode = Text(
                          e.target,
                          50,
                          true,
                          false,
                          "any",
                          true
                        )
                        SetVoucherTo(valCode)
                      }}
                      Gen_VoucherTo_Enabled={blVoucherToEnable}
                      Gen_BookFrom={strBookFrom}
                      Gen_BookFrom_OnChange={e => {
                        let valCode = Text(
                          e.target,
                          50,
                          true,
                          false,
                          "any",
                          true
                        )
                        SetBookFrom(valCode)
                      }}
                      Gen_BookFrom_Enabled={blBookFromEnable}
                      Gen_BookTo={strBookTo}
                      Gen_BookTo_OnChange={e => {
                        let valCode = Text(
                          e.target,
                          50,
                          true,
                          false,
                          "any",
                          true
                        )
                        SetBookTo(valCode)
                      }}
                      Gen_BookTo_Enabled={blBookToEnable}
                      Gen_GRNNo={strGrnNo}
                      Gen_GRNNo_OnChange={e => {
                        let valCode = Text(
                          e.target,
                          50,
                          true,
                          false,
                          "any",
                          true
                        )
                        SetGrnNo(valCode)
                      }}

                      Gen_VoucherFromSearch={async () => {
                        // let data = await getVoucherNumber()

                        // let i = 1
                        // data.map(r => {
                        //   searchDataVoucher = searchDataVoucher.concat(
                        //     TableDataBuilderVoucher(i, r)
                        //   )
                        //   i++
                        // })

                        // SetDatatableVoucher(searchDataVoucher)
                        tog_xlargeFromvoucher()
                      }}
                      Gen_VoucherToSearch={async () => {
                        // let data = await getVoucherNumber()

                        // let i = 1
                        // data.map(r => {
                        //   searchDataVoucher = searchDataVoucher.concat(
                        //     TableDataBuilderVoucher(i, r)
                        //   )
                        //   i++
                        // })
                        // SetDatatableVoucher(searchDataVoucher)
                        tog_xlargeTovoucher()
                      }}
                      Gen_BookFromSearch={async () => {
                        // let data = await getVoucherBook()

                        // let i = 1
                        // data.map(r => {
                        //   searchDataBook = searchDataBook.concat(
                        //     TableDataBuilderBook(i, r)
                        //   )
                        //   i++
                        // })
                        // SetDatatableBook(searchDataBook)
                        tog_xlargeFromBook()
                      }}
                      Gen_BookToSearch={async () => {
                        // let data = await getVoucherBook()

                        // let i = 1
                        // data.map(r => {
                        //   searchDataBook = searchDataBook.concat(
                        //     TableDataBuilderBook(i, r)
                        //   )
                        //   i++
                        // })
                        // SetDatatableBook(searchDataBook)
                        tog_xlargeToBook()
                      }}
                      Gen_GRNNoSearch={async () => {
                        // let data = await getVoucherGRNSearch(LocationCode)

                        // let i = 1
                        // data.map(r => {
                        //   searchDataGrn = searchDataGrn.concat(
                        //     TableDataBuilderGrn(i, r)
                        //   )
                        //   i++
                        // })
                        // SetDatatableGRN(searchDataGrn)
                        tog_xlargeGrn()
                      }}

                      SearchDataTablesVouFrom={DataTablesVoucher}
                      SearchColumnsVouFrom={columnsVoucher}
                      SearchDefaultSortedVouFrom={defaultSorted}
                      SearchModelOpenVouFrom={modal_xlargeVoucherFrom}
                      SearchModelTriggerVouFrom={tog_xlargeFromvoucher}
                      SearchGetSelectRowVouFrom={GetSelectRowVoucherFrom}

                      SearchDataTablesVouTo={DataTablesVoucher}
                      SearchColumnsVouTo={columnsVoucher}
                      SearchDefaultSortedVouTo={defaultSorted}
                      SearchModelOpenVouTo={modal_xlargeMainVoucherTo}
                      SearchModelTriggerVouTo={tog_xlargeTovoucher}
                      SearchGetSelectRowVouTo={GetSelectRowVoucherTo}

                      SearchDataTablesBookFrom={DataTablesBook}
                      SearchColumnsBookFrom={columnsBook}
                      SearchDefaultSortedBookFrom={defaultSorted}
                      SearchModelOpenBookFrom={modal_xlargeBookFrom}
                      SearchModelTriggerBookFrom={tog_xlargeFromBook}
                      SearchGetSelectRowBookFrom={GetSelectRowBookFrom}

                      SearchDataTablesBookTo={DataTablesBook}
                      SearchColumnsBookTo={columnsBook}
                      SearchDefaultSortedBookTo={defaultSorted}
                      SearchModelOpenBookTo={modal_xlargeBookTo}
                      SearchModelTriggerBookTo={tog_xlargeToBook}
                      SearchGetSelectRowBookTo={GetSelectRowBookTo}

                      SearchDataTablesGRN={DataTablesGRN}
                      SearchColumnsGRN={columnsGrn}
                      SearchDefaultSortedGRN={defaultSorted}
                      SearchModelOpenGRN={modal_xlargeGrn}
                      SearchModelTriggerGRN={tog_xlargeGrn}
                      SearchGetSelectRowGRN={GetSelectRowMainGrn}

                      AlertColor={AlertColor}
                      AlertMsg={AlertMsg}
                      show={AlertShow}
                      Gen_LoadVouchersSearch={async () => {
                        let DataLoadVoucher = await getVoucherPrintSummary(strVoucherFrom, strVoucherTo, strBookFrom, strBookTo, strGrnNo)
                        setLoadVoucher(DataLoadVoucher.length > 0 ? DataLoadVoucher : [{ id: 1 }])

                      }}
                      menuCode={menuCode}
                      LocationCode={LocationCode}
                    />
                  </Row>
                  <Row>
                    <VoucherBarcodePrintDetails
                      DataRow={rowsLoadVoucher}
                      Disabled={disabled}
                      rowsTax={rowsTax}
                      ShowTaxTable={ShowTaxTable}
                      blDiasableGrid={blDiasableGrid}
                      handleClearStatus={handleClearStatus}


                    />
                  </Row>

                  <Row>
                    {crEnable ? (
                      <DPInfoBox
                        createdBy={crBy}
                        createdOn={crDate}
                        modifiedBy={mdBy}
                        modifiedOn={mdDate}
                      />
                    ) : null}
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default VoucherBarcodePrint